const SIZES = {
  // A row of a record's list (« Entreprises du groupe », a contact's companies).
  md: { box: 'h-9 w-9 rounded-lg', icon: 18 },
  // A row of a picker (PickOption).
  sm: { box: 'h-8 w-8 rounded-lg', icon: 16 },
  // A cell of a table (« Lié à »).
  xs: { box: 'h-7 w-7 rounded-md', icon: 16 },
};

/**
 * The icon of a line that names a record (a company, a group, a contact): a
 * white square with a light border, as in « Entreprises du groupe ».
 * `icon` takes the `{ wh, color }` props of assets/icons.
 */
const ListIcon = ({ icon: Icon, size = 'md' }) => {
  const { box, icon } = SIZES[size] ?? SIZES.md;
  return (
    <span className={`flex shrink-0 items-center justify-center border border-gray-100 bg-white text-gray-900 ${box}`}>
      <Icon wh={icon} color="currentColor" />
    </span>
  );
};

export default ListIcon;
